import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

const PAD_LENGTH = 2;
const PAD_CHAR = '0';

function padTwo(value: number): string {
  return String(value).padStart(PAD_LENGTH, PAD_CHAR);
}

function isInvalidDate(date: Date | null): date is null {
  return isNil(date) || isNaN(date.getTime());
}

/**
 * Formats an ISO 8601 date string to "DD.MM.YYYY HH:MM".
 * Returns empty string for invalid date inputs.
 */
export function formatAuctionEndDate(isoString: string): string {
  const date = parseDate(isoString);
  if (isInvalidDate(date)) {
    return '';
  }
  const day = padTwo(date.getDate());
  const month = padTwo(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = padTwo(date.getHours());
  const minutes = padTwo(date.getMinutes());

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

/**
 * Formats an ISO 8601 date string to a localized "Ends DD Mon YYYY at HH:MM" string.
 * Uses Intl.DateTimeFormat for locale-aware month names.
 * Returns empty string for invalid date inputs.
 */
export function formatAuctionEndDateLong(isoString: string): string {
  const date = parseDate(isoString);
  if (isInvalidDate(date)) {
    return '';
  }
  const day = date.getDate();
  const month = new Intl.DateTimeFormat(undefined, {month: 'short'}).format(date);
  const year = date.getFullYear();
  const hours = padTwo(date.getHours());
  const minutes = padTwo(date.getMinutes());

  return i18n.t('entity.auction.labels.endsAt', {
    date: `${day} ${month} ${year}`,
    time: `${hours}:${minutes}`,
  });
}
